import datepicker from 'js-datepicker'
export default function DayProgram() {

  if(!document.querySelector('[data-day-program-date]')) return

  const picker = datepicker('[data-day-program-date]', {
    onSelect: (instance, date) => {
      const loader = jQuery('#loader')
      loader.addClass('show')

      const dateString = date.getFullYear() + '-' + (date.getMonth() + 1 + '').padStart( 2, '0' )  + '-' + (date.getDate() + '').padStart( 2, '0' )
      let endpoint = window?.main_theme_objects?.rest_api_endpoints?.day_program
      endpoint = endpoint.replace('[date]', dateString)

      // Ajax call
      jQuery.get(
        endpoint,
        (response) => {
          if (response.hasOwnProperty('markup')) {
            jQuery('.mtt-day-program__programs').html(response.markup)
          }

          // Hide loader
          loader.removeClass('show')
        })
    },
    formatter: (input, date, instance) => {
      const formatter = new Intl.DateTimeFormat('da', { month: 'long' });
      const value = `${date.getDate()} ${formatter.format(date)} ${date.getFullYear()}`
      input.value = value
    },
    minDate: new Date(),
    startDay: 1,
    customDays: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø']
  })

  jQuery(document).on('click', '.mtt-day-program__program--has-description .mtt-day-program__program--title-wrap', function() {
    jQuery(this).toggleClass('open')
    jQuery(this).parent().parent().parent().parent().find('.mtt-day-program__program-description').toggleClass('open')
  })


}
